/**
 * Design Tokens (JS Access)
 *
 * SOURCE OF TRUTH: src/index.css @theme block.
 * This file MIRRORS those values for JS contexts that can't use CSS classes:
 *   - SVG fill/stroke colors (DuotoneIcon)
 *   - Inline HTML styles (ShareButton print dialog)
 *   - <meta> tags (SEOHead theme-color)
 *   - Style guide display (StyleGuide)
 *
 * If you update a color in index.css @theme, update it here too.
 */
export const DESIGN_TOKENS = {
  colors: {
    brandSun: 'var(--color-brand-sun, #f8951f)',
    brandSunLight: 'var(--color-brand-sun-light, #fbbf24)',
    brandOcean: 'var(--color-brand-ocean, #126588)',
    brandOceanDark: 'var(--color-brand-ocean-dark, #0c4a6e)',
    brandOceanLight: 'var(--color-brand-ocean-light, #0ea5e9)',
    brandGray: 'var(--color-brand-gray, #64748b)',
    brandGrayDark: 'var(--color-brand-gray-dark, #475569)',
    brandGrayLight: 'var(--color-brand-gray-light, #94a3b8)',
    brandSand: 'var(--color-brand-sand, #f8fafc)',
    brandSandDark: 'var(--color-brand-sand-dark, #d97706)',
    surface: 'var(--color-surface, #ffffff)',
    surfaceMuted: 'var(--color-surface-muted, #f8fafc)',
    border: 'var(--color-border, #e2e8f0)',
    textMain: 'var(--color-text-main, #126588)',
    textMuted: 'var(--color-text-muted, #64748b)',
    textStrong: 'var(--color-text-strong, #0f172a)',
    danger: 'var(--color-danger, #be123c)',
    dangerSoft: 'var(--color-danger-soft, #fff1f2)',
    success: 'var(--color-success, #10b981)',
    successLight: 'var(--color-success-light, #34d399)',
    error: 'var(--color-error, #ef4444)',
    errorLight: 'var(--color-error-light, #f87171)',
    white: '#ffffff',
    slate100: '#f1f5f9',
    amber400: '#f59e0b',
    amber300: '#fcd34d',
    cyan300: '#67e8f9',
    cyan200: '#a5f3fc',
  },
  typography: {
    fontSans: 'Inter, ui-sans-serif, system-ui, sans-serif',
    display: 'clamp(2.25rem, 5vw, 4rem)',
    heading: 'clamp(1.75rem, 3.5vw, 3rem)',
    body: '1rem',
    small: '0.875rem',
  },
  spacing: {
    controlX: '1rem',
    controlY: '0.75rem',
    card: '1.5rem',
    sectionY: '4rem',
  },
  radius: {
    control: '0.75rem',
    card: '1.5rem',
    panel: '2rem',
    hero: '2.5rem',
  },
} as const;

export type DesignTokens = typeof DESIGN_TOKENS;
